import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { RecallCommunicationItem } from "./RecallCommunicationItem";

class RecallCommunicationListItem implements ITableDataSourceItem<RecallCommunicationItem> {
    public Model: RecallCommunicationItem;
    public Name: string;

    constructor(model: RecallCommunicationItem) {
        this.Model = model;
    }
}

export { RecallCommunicationListItem };
